export default __webpack_public_path__ + "static/media/Flag_of_Canada.e2a30f78.jpg";